import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Hata yakalandığında state'i güncelle
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Hata bilgilerini logla ve state'e kaydet
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // Hata varsa kullanıcı dostu hata sayfası göster
      return (
        <div className="container" style={{ padding: '50px', textAlign: 'center' }}>
          <div className="block">
            <div className="header">
              <h3>
                <i className="fas fa-exclamation-triangle" style={{ color: 'red' }}></i>{' '}
                Bir Hata Oluştu
              </h3>
            </div>
            <div style={{ padding: '20px' }}>
              <p>Üzgünüz, bir şeyler ters gitti.</p>
              <button
                className="button-pos save"
                onClick={() => window.location.reload()}
                style={{ marginTop: '20px' }}>
                <i className="fas fa-redo"></i> Sayfayı Yenile
              </button>
              {process.env.NODE_ENV === 'development' && (
                <details style={{ marginTop: '20px', textAlign: 'left' }}>
                  <summary>Hata Detayları (Sadece Geliştirme Modunda)</summary>
                  <pre style={{ color: 'red', fontSize: '12px', overflow: 'auto' }}>
                    {this.state.error && this.state.error.toString()}
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    // Hata yoksa normal içeriği göster
    return this.props.children;
  }
}

export default ErrorBoundary;

